
export const spanMixin = {
  props: {
    extendRowConfig: {
      type: Object,
      default: null
    },
  },
  computed: {
    proxySpanMethod() {
      /**
       * 数据底部扩展行配置
       * 需要横跨一行横跨table的行
       */
      const extendRowConfig = this.extendRowConfig;
      /**
       * 懒加载
       * 需要横跨一行用于展示展开行
       */
      const expandLazyLoad = this.expand && this.expandLazyLoad;
      /**
       * 原span方法
       */
      const spanMethod = this.$attrs['span-method'] || this.$attrs['spanMethod'];
      /**
       * 父子结构数据格式
       * 父级数据需要横跨一行
       */
      const parentChildStructure = this.parentChildStructure;

      /**
       * 判断是否需要返回spanMethod
       * 注：不能随意返回方法作为属性，会有性能问题
       */
      if (extendRowConfig || expandLazyLoad || spanMethod || parentChildStructure) {
        return ({row, column, rowIndex, columnIndex}) => {
          if (this.extendRowConfig && row.$gjExtendRowAlias) {
            if (this.selection) {
              if (columnIndex === 0) {
                return {
                  rowspan: 1,
                  colspan: 1
                };
              } else if (columnIndex === 1) {
                return {
                  rowspan: 1,
                  colspan: this.$refs.gjTable.collectColumn.length
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                }
              }
            } else {
              if (columnIndex === 0) {
                return {
                  rowspan: 1,
                  colspan: this.$refs.gjTable.collectColumn.length
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                }
              }
            }
          }
          if (row.$gjExpandRow) {
            if (columnIndex === 0) {
              return {
                rowspan: 1,
                colspan: this.$refs.gjTable.collectColumn.length
              };
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
          if (this.$attrs['span-method'] || this.$attrs['spanMethod']) {
            return (this.$attrs['span-method'] || this.$attrs['spanMethod'])({row, column, rowIndex, columnIndex});
          }
          if (this.parentChildStructure) {
            const spanType = this.structureConfig['spanType'] ? this.structureConfig['spanType'] : 'col';
            // 跨列
            if (spanType === 'col') {
              if (row.$gjDataType === '$gjParentData') {
                if (this.selection && columnIndex === 0) {
                  return {
                    rowspan: 1,
                    colspan: 1
                  }
                } else if (columnIndex === this.structureConfig['parentSpan'][0]) {
                  const colspan = this.selection
                    ? this.structureConfig['parentSpan'][1]
                    : this.structureConfig['parentSpan'][1] + 1;
                  return {
                    rowspan: 1,
                    colspan: colspan
                  };
                } else if (columnIndex > this.structureConfig['parentSpan'][1] || columnIndex < this.structureConfig['parentSpan'][0]) {
                  return {
                    rowspan: 1,
                    colspan: 1
                  }
                } else {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              }
            }
            // 跨行
            if (spanType === 'row') {
              // parentSpan: ['0-1', 6]
              const spanList = this.structureConfig['parentSpan']
                .map(item => {
                  if (typeof item === 'string') {
                    const tmp = item.split('-');
                    return [Number(tmp[0]), Number(tmp[1])];
                  }
                  return [item, item];
                });
              for (let i = 0; i < spanList.length; i++) {
                const span = spanList[i];
                const spanColumn = span[0] <= columnIndex && columnIndex <= span[1];
                if (row.$gjParentData) {
                  if (spanColumn) {
                    return {
                      rowspan: row.$gjRowSpan,
                      colspan: 1
                    }
                  }
                } else {
                  if (spanColumn) {
                    return {
                      rowspan: 0,
                      colspan: 0
                    }
                  }
                }
              }
            }
          }
        }
      }
      return null;
    },
  }
};
